// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// Base Imports
import Vue from 'vue'
import App from './App'
// Packages
import Axios from 'axios'
// import VueGeolocation from 'vue-browser-geolocation'
import _ from 'lodash'
import VueContentPlaceholders from 'vue-content-placeholders'
import * as VueGoogleMaps from 'vue2-google-maps'
// eslint-disable-next-line no-unused-vars
// import LogRocket from 'logrocket'

// Layouts
import Default from './layouts/Default.vue'
import Guest from './layouts/Guest.vue'
import Merchant from './layouts/Merchant.vue'

import store from './store'
import configHelper from './helpers/config'
// Routing
import router from './router'

import coreMixin from './mixins/coreMixin'
// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faStar as fasFaStar, faBarcode as fasBarcode } from '@fortawesome/free-solid-svg-icons'
import { faStar as farFaStar } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import LoadScript from 'vue-plugin-load-script'
import NProgress from 'nprogress'

import i18n from './i18n.js'
import VueMask from 'v-mask'

// State and Store
let appConfigs = require(`@/assets/client/${process.env.CLIENTID}/site_config.json`)

configHelper.initializeApplicationSettings(store, appConfigs)

Vue.use(VueMask)

import(`./assets/css/font-face.css`)
import(`./assets/css/font-sizes.css`)
import(`./assets/css/font-utility-helper.css`)
import(`./assets/client/${process.env.CLIENTID}/css/styles.css`)

Vue.use(NProgress)
NProgress.configure({
  template: '<div class="bar" role="bar">' +
    '           <div class="peg"></div>' +
    '        </div>' +
    '        <div class="spinner" role="spinner">' +
    '           <div class="spinner-icon"></div>' +
    '        </div>' +
    '<div id="modal-full" class="uk-modal-full" uk-modal>' +
    '    <div class="uk-modal-dialog" style="min-height: 100%;">' +
    '     <div class="uk-padding-large">' +
    '                                             <div class="uk-position-center">\n' +
'                    <img src="data:image/png;base64,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" alt="Get Perked Logo" width="250" height="34">' +
    '<br><br><br><br><br><br><br><br>' +
    '</div>' +
    '              <h3 class="uk-position-center"><br><br>Loading</h3>' +
    '<div class="uk-position-center" uk-spinner="ratio: 3"></div>\n' +
  '            </div>' +
    '    </div>' +
    '</div>'
})
Vue.use(LoadScript)

Vue.component(VueQrcode.name, VueQrcode)

library.add(fasFaStar, farFaStar, fasBarcode)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// if (_.get(appConfigs, 'logrocket_id')) {
//   console.log('***Loading LogRocket***')
//   LogRocket.init(appConfigs.logrocket_id)
// }

Vue.use(VueContentPlaceholders)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCChLpwlDDUPWxkEcXlBPzyW_uiZatZ3Oo',
    libraries: 'places' // This is required if you use the Autocomplete plugin
  }
})
Vue.mixin(coreMixin)
Vue.prototype.$http = Axios
Vue.component('default-layout', Default)
Vue.component('guest-layout', Guest)
Vue.component('merchant-layout', Merchant)

Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.filter('rounddown', function (value) {
  if (!value) return 0
  return Math.floor(value)
})

Vue.filter('twodecimal', function (value) {
  if (isNaN(value)) {
    return ''
  } else {
    return parseFloat(value).toFixed(2)
  }
})

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

console.log(navigator.userAgent)
if (navigator.userAgent.match(/(cordova)/)) {
  document.addEventListener('deviceready', onDeviceReady, false)
} else {
  onDeviceReady()
}

function onDeviceReady () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    i18n
  })
}



// WEBPACK FOOTER //
// ./src/main.js